import { isToday } from 'date-fns/isToday';

import { ZonedDate } from '@eika-infrastruktur/date';

export const isNotToday = (date: ZonedDate | undefined) => !!date && !isToday(date);

export default isNotToday;
